module.exports = __webpack_public_path__ + "img/v2_5.ffa30c40.png";